<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2016-06-10</p>
    <div class="content">
      <!-- 第一段内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>

      <!-- 第一张图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url">

        </div>
      </div>

      <!-- 第二段内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <!-- 第二张图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture2?.url">
        </div>
      </div>

      <!-- 第三段内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>

      <!-- 第三张图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture3?.url">
        </div>
      </div>
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture4?.url">
        </div>
      </div>
      <!-- 第四段内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[3] || ''"></p>
        </div>
      </div>

      <!-- 超导低空列车部分 -->
      <div class="content-section">
        <div class="text-block">
          <h3 v-html="formatHighlight(currentNews.content?.split('---')[4] || '')"></h3>
          <p v-html="currentNews.content?.split('---')[5] || ''"></p>
        </div>
      </div>

      <!-- 超导低空列车图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture5?.url">
        </div>
      </div>

      <!-- 超导感应加热设备部分 -->
      <div class="content-section">
        <div class="text-block">
          <h3 v-html="formatHighlight(currentNews.content?.split('---')[6] || '')"></h3>
          <p v-html="currentNews.content?.split('---')[7] || ''"></p>
        </div>
      </div>

      <!-- 感应加热设备图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture6?.url">
        </div>
      </div>

      <!-- 超导电缆部分 -->
      <div class="content-section">
        <div class="text-block">
          <h3 v-html="formatHighlight(currentNews.content?.split('---')[8] || '')"></h3>
          <p v-html="currentNews.content?.split('---')[9] || ''"></p>
        </div>
      </div>

      <!-- 超导电缆图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture7?.url">
          <p class="image-caption">{{ currentNews.other?.picture7?.caption }}</p>
        </div>
      </div>

      <!-- 超导电机部分 -->
      <div class="content-section">
        <div class="text-block">
          <h3 v-html="formatHighlight(currentNews.content?.split('---')[10] || '')"></h3>
          <p v-html="currentNews.content?.split('---')[11] || ''"></p>
        </div>
      </div>

      <!-- 超导电机图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture6?.url">
          <p class="image-caption">{{ currentNews.other?.picture8?.caption }}</p>
        </div>
      </div>

      <!-- 结尾段落 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[12] || ''"></p>
        </div>
      </div>

    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'kejichuangxin');
  return newsItem || {};
});

// 处理高亮文本
const formatHighlight = (text: string) => {
  if (!text) return '';
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlight">$1</span>');
};
</script>

<style scoped lang="scss">


.page-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}

.content-section {
  margin-bottom: 30px;
}

.text-block {
  line-height: 1.6;
  
  p {
    margin-bottom: 15px;
  }
  
  h3 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #1a56db;
  }
  
  :deep(.highlight) {
    font-weight: bold;
    color: #1a56db;
  }
}

.image-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.image-container {
  margin-bottom: 20px;
  max-width: 100%;
  text-align: center;
  
  img {
    max-width: 100%;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
}

.image-caption {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #666;
}
</style> 